var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1NewHair4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair4_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M585.3,218.3c-1-35.2-12.4-69.8-37.4-95.6c-3.7-4.1-7.6-8.1-11.7-11.9c-26.5-24.6-60.8-50.5-95.7-61.3 c-24.8-9.2-47.9-11.9-68-13c-62-3.4-161.4,34.3-210,95c-5.8,6-11.2,12.3-16.6,18.6c-3.6,4.4-7,8.8-10.3,13.2 c-11.4,15.6-21.2,32.2-29,49.8c-1.9,4.4-3.8,8.9-5.5,13.4c-17.6,47-23.9,106.4,5.2,149.9c1.9,3.4,4.2,6.5,7,9.5 c2.4,2.6,8.5,8.9,12.6,6.6c2.1-1.2,5.7-8.9,7.6-11.2c2.6-3.3,5.8-6.4,8.8-9.5c3-3,6-5.7,8.5-8.5c4.1-4.1,7.4-9.7,7.2-14 c-0.7-21.3,0-38,7-46.7c12-14.9,10.8-15.6,17.3-33.3c7.2-19.6,15-18.7,28-30.7c7.2-6.6,5.7-20.7,7.4-32.7l13.6-1.3 c34.7-23.9,62.9-37.8,107-45c36.5-5.9,86.3-6.7,119.2,10.7c12.3,6.5,26.1,18.3,32.8,30.4c0.3-1.8,0.9-3.6,1.8-5.5l5.1,9.8 c0.3,23.3,13.4,43.6,27.8,61.9c18.3,23.2,11.2,63.7,21.9,70.4c6.6-9.7,11.4-18.8,15.1-27.8c13.6-23.1,21.4-49.1,22.8-76 C585.3,228.4,585.4,223.3,585.3,218.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_9_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M510,193.3l-0.6-17.1c-1.1-15.6-0.4-18.4-7.4-20.8c-1.3-0.4-2.6-0.9-4-1.3c-19.6-6.4-40.1-11-61-14.2 c-3.7-0.6-7.5-1.1-11.2-1.6c-30.6-5.1-62-7.7-93.7-7.1c-4,0.1-7.9,0.2-11.9,0.4c-34.6,1.8-69,6.9-100.5,17.9 c-1.5,0.5-2.9,1-4.4,1.6c-3.2,1.2-11.4-0.2-5.7,47.8l0.1,3.4c1.3,9.6,6.3,11.3,11.3,9.8c0.4-0.1,0.8-0.2,1.2-0.4 c2.1-0.6,4.2-1.2,6.4-1.8c15.6-4,31.5-7,47.7-9.1c8.1-1,16.2-1.9,24.5-2.5c38.6-2.6,76.8-2.1,114.5,1.8c7.5,0.7,15,1.7,22.4,2.8 c14.6,2.2,29,5.2,43.1,8.9C495.2,215.8,511.5,223.2,510,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M332.1,131.2c31.8-0.6,63.2,2,93.7,7.1c3.7,0.5,7.5,1,11.2,1.6c20.9,3.2,41.4,7.9,61,14.2 c0.2-2.6,0.3-5.2,0.2-7.9c0-3.3-0.3-6.6-0.7-9.9c-3-24.1-15.1-49.4-36.9-66.8c-3.1-2.5-6.4-4.8-9.9-7 c-18.5-11.8-41-16.7-64.3-18.2c-3.9-0.2-7.8-0.4-11.7-0.5c-41.3-0.1-87,3.4-118.2,27.3c-3.3,2.4-6.3,4.8-9.2,7.5 c-20.7,19.2-28.8,45.1-27.7,70.8c31.5-11,65.9-16.1,100.5-17.9C324.1,131.4,328.1,131.3,332.1,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M493,149.5c-2.7-1.1-5.4-2.1-8.1-3.2c-18.2-6.7-37.2-12.1-56.6-16.4c-3.9-0.9-7.8-1.7-11.7-2.4 c-43.2-8.3-87.6-9.7-131.4-5.7c-4,0.4-7.9,0.8-11.8,1.4c-7.8,1.1-15.5,2.5-23,4.4c4.1-31.2,25-60.6,57-78c0.2-0.1,0.3-0.2,0.5-0.3 c-19,4-36.8,10.7-51.4,21.9c-3.3,2.4-6.3,4.8-9.2,7.5c-20.7,19.2-28.8,45.1-27.7,70.8c31.5-11,65.9-16.1,100.5-17.9 c4-0.2,8-0.3,11.9-0.4c31.8-0.6,63.2,2,93.7,7.1c3.7,0.5,7.5,1,11.2,1.6c20.9,3.2,41.4,7.9,61,14.2c0.1-0.8,0.1-1.7,0.1-2.5 C496.4,150.9,494.7,150.2,493,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M239.8,188c7.4-14.4,16-29.3,9.3-46.9c-10,2.3-19.9,5.1-29.5,8.4c-1.5,0.5-2.9,1-4.4,1.6 c-3.2,1.2-11.4-0.2-5.7,47.8l0.1,3.4c1.3,9.6,6.3,11.3,11.3,9.8c0.4-0.1,0.8-0.2,1.2-0.4c2.1-0.6,4.2-1.2,6.4-1.8 c5.3-1.4,10.6-2.6,16-3.7C241.4,200.2,237.5,193.5,239.8,188z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M364.4,33.3c-12.6-6.6-27.5,1.4-30.1,12.1c12.2-1.1,24.5-1.5,36.5-1.6C370.1,39.9,368.9,35.6,364.4,33.3z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M319.3,134.9c4-0.2,8-0.3,11.9-0.4c31.8-0.6,63.2,2,93.7,7.1c3.7,0.5,7.5,1,11.2,1.6 c24.7,3.8,49,9.6,71.8,17.9c-0.8-3.1-2.4-4.5-6-5.7c-1.3-0.4-2.6-0.9-4-1.3c-7.2-2.3-14.6-4.4-22-6.3l-0.3-7.2 c-3.7-31.6-17-58.3-43.2-81.2c26,23.2,36.9,50.4,40.3,81.3l0.3,6.4c-11.8-2.9-23.8-5.3-35.9-7.1l-0.7-6.7 c-4.3-30.1-15-55.1-33-80.8c17.6,26,26,51.3,30,81.1l0.6,6c-2.8-0.4-5.6-0.8-8.4-1.2c-10.6-1.8-21.3-3.2-32.1-4.4l-0.3-6.2 c-1.5-27.7-3-51.8-13.8-77.7c10.4,26.1,9.5,50.1,10.9,77.8l0.3,5.8c-11.1-1.1-22.3-1.8-33.6-2.2l0.1-5.9 c0.1-26.6-2.3-49.2-6.5-74.9c3.9,25.8,3.9,48.4,3.6,74.9l-0.1,5.9c-7.4-0.2-14.8-0.2-22.2-0.1c-4,0.1-7.9,0.2-11.9,0.4 c-1.5,0.1-3.1,0.2-4.6,0.3l-0.4-5.4c-1.7-26.3-1.7-49.6,10.4-73.9c-12.5,24.1-15,47.5-13.3,74c0.1,1.8,0.3,3.6,0.4,5.4 c-12.2,0.8-24.4,2.1-36.4,3.9c-0.3-1.7-0.7-3.4-0.9-5.2c-2.6-24.6,1.3-46.4,12.9-69c-11.9,22.4-18.3,43.9-15.8,69.2 c0.2,1.8,0.6,3.6,0.9,5.4c-8.2,1.3-16.3,2.8-24.2,4.7c-0.2-1.5-0.5-3-0.6-4.6c-1.6-22.6,3-42.2,11.7-63.5 c-9.1,21.1-16.1,40.3-14.7,63.6c0.1,1.7,0.4,3.4,0.6,5.1c-9.1,2.2-18,4.7-26.6,7.8c-1.5,0.5-2.9,1-4.4,1.6 c-1.5,0.5-4.1,0.5-5.8,5.2c3.4-1.3,6.9-2.6,10.4-3.8C251.1,141.7,285,136.7,319.3,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M415.5,196.3c-37.7-4-75.9-4.4-114.5-1.8c-8.2,0.6-16.4,1.5-24.5,2.5c-16.2,2.1-32.1,5.1-47.7,9.1 c-2.5,0.7-5.1,1.4-7.6,2.1c-2.7,0.8-5.4,1.7-8.1,2.7c2.1,1.9,4.9,2.1,7.6,1.3c0.4-0.1,0.8-0.2,1.2-0.4c2.1-0.6,4.2-1.2,6.4-1.8 c15.6-4,31.5-7,47.7-9.1c8.1-1,16.2-1.9,24.5-2.5c38.6-2.6,76.8-2.1,114.5,1.8c7.5,0.7,15,1.7,22.4,2.8c14.6,2.2,29,5.2,43.1,8.9 c8.1,2.2,16.8,5.4,22.6,2.7c-20.9-7.1-42.8-12.2-65.2-15.6C430.5,197.9,423,197,415.5,196.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M239.1,200.8c-7.4-16.5-5.9-31.5-4.7-47.9c-0.6,16.5,1.5,31.2,8.7,46.7l2.1,4.1l-3.9,1.4L239.1,200.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M267.1,195.6c-5.9-16.9-6.9-32-4.2-48.6c-2.1,16.8,2.4,31.4,8.3,47.6c0.5,1.5,1.2,2.9,1.8,4.3l-4,1.2 C268.4,198.6,267.6,197.2,267.1,195.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M299.4,192c-4.2-17.1-5.7-32.1-4.7-49.1c-0.3,17.1,4.6,31.5,8.9,48.4l1.2,4.5l-4.2,0.7L299.4,192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M334.6,190.3c-3.4-17.6-1.2-32.7,1.7-49.6c-2.4,17-1,32,2.5,49l1,4.6l-4.2,0.7L334.6,190.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M371.2,190.2c3.3-17.4,6-32.4,4-49.7c2.6,17.2,3.4,32.6,0.2,50.3l-0.9,4.7l-4.2-0.6L371.2,190.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M411.7,193.4c4.7-16.9,6.9-32.1,3.1-49.2c4.4,16.9,5.7,32.4,1.1,50l-1.5,4.7l-4.1-0.9L411.7,193.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M451.3,199.3c3.1-16.2,4.7-30.5,1.2-46.6c4.1,15.9,6.1,30.4,3,47.1l-1,4.4l-4.2-0.7L451.3,199.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M479.9,204.8c4.1-15.6,7.3-29.4,6-45.3c2,15.8,2.3,29.9-1.8,46.1l-1.3,4.3l-4.1-0.9L479.9,204.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M310.4,56.9c-0.4,1.6-1.5,2.8-2.5,2.6s-1.5-1.6-1.1-3.2c0.4-1.6,1.5-2.8,2.5-2.6 C310.3,53.8,310.8,55.3,310.4,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M300.1,80.9c-0.3,1.3-1.3,2.3-2.1,2.1c-0.8-0.1-1.2-1.3-0.9-2.6c0.3-1.3,1.3-2.3,2.1-2.1 C300.1,78.4,300.5,79.5,300.1,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M261.1,109.5c-0.3,1.3-1.3,2.3-2.1,2.1c-0.8-0.1-1.2-1.3-0.9-2.6c0.3-1.3,1.3-2.3,2.1-2.1 C261.1,107,261.5,108.2,261.1,109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M254.3,187c0,1.3-0.6,2.4-1.5,2.5c-0.8,0-1.6-1.1-1.6-2.4s0.6-2.4,1.5-2.5 C253.6,184.5,254.3,185.6,254.3,187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M285,146.8c0,1.6-0.7,2.9-1.8,2.9c-1,0-1.9-1.3-1.9-2.9c0-1.6,0.7-2.9,1.8-2.9 C284.1,143.9,285,145.2,285,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M281.8,184.8c0.4,1.6-0.1,3-1.1,3.1c-1,0.2-2.1-1-2.5-2.6s0.1-3,1.1-3.1 C280.3,182,281.4,183.2,281.8,184.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M315,167c0.3,1.6-0.3,3-1.3,3.1s-2-1.1-2.3-2.7c-0.3-1.6,0.3-3,1.3-3.1S314.7,165.4,315,167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M326.8,141.5c-0.1,1.6-0.9,2.9-1.9,2.9s-1.8-1.3-1.7-3c0.1-1.6,0.9-2.9,1.9-2.9 C326,138.5,326.8,139.9,326.8,141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M355.4,145.2c-0.1,1.6-0.9,2.9-1.9,2.9s-1.8-1.3-1.7-3c0.1-1.6,0.9-2.9,1.9-2.9 C354.7,142.3,355.5,143.6,355.4,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M350.4,182.2c-0.1,1.6-0.9,2.9-1.9,2.9s-1.8-1.3-1.7-3c0.1-1.6,0.9-2.9,1.9-2.9 C349.7,179.2,350.4,180.6,350.4,182.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M393.9,157.2c-0.1,1.6-0.9,2.9-1.9,2.9s-1.8-1.3-1.7-3c0.1-1.6,0.9-2.9,1.9-2.9 C393.1,154.3,393.9,155.6,393.9,157.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M398.2,185.3c-0.3,1.6-1.3,2.8-2.3,2.7s-1.6-1.5-1.3-3.1c0.3-1.6,1.3-2.8,2.3-2.7 C397.9,182.4,398.5,183.7,398.2,185.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M439.9,179.9c-0.3,1.6-1.3,2.8-2.3,2.7s-1.6-1.5-1.3-3.1c0.3-1.6,1.3-2.8,2.3-2.7 S440.2,178.3,439.9,179.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M468.8,163.2c0,1.6-0.8,2.9-1.8,2.9s-1.8-1.3-1.8-2.9s0.8-2.9,1.8-2.9S468.8,161.6,468.8,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M470.9,195.2c-0.2,1.6-1.1,2.8-2.1,2.8c-1-0.1-1.7-1.4-1.5-3s1.1-2.8,2.1-2.8S471.1,193.6,470.9,195.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M498.2,166.8c0,2-1.1,3.6-2.4,3.6c-1.2,0-2.2-1.7-2.2-3.7s1.1-3.6,2.3-3.6 C497.3,163.1,498.3,164.8,498.2,166.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M291.7,109.3c-0.3,1.4-1.2,2.4-2.1,2.3s-1.4-1.3-1.1-2.7c0.3-1.4,1.2-2.4,2.1-2.3 C291.5,106.7,291.9,107.9,291.7,109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M271.8,72.2c-0.9,1.7-2.4,2.7-3.4,2.4c-1-0.3-1.2-2-0.3-3.6c0.9-1.7,2.4-2.7,3.4-2.4 C272.5,68.9,272.7,70.5,271.8,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M241.3,108.3c-0.5,1.7-1.9,3-3,2.8s-1.5-1.8-1-3.6c0.5-1.7,1.9-3,3-2.8 C241.4,105,241.8,106.6,241.3,108.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M232.8,130.7c-0.1,1.8-1.1,3.2-2.2,3.2c-1.1,0-2-1.5-1.9-3.3s1.1-3.2,2.2-3.2 C232.1,127.4,232.9,128.9,232.8,130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M222,178.5c-0.1,1.8-1.1,3.2-2.2,3.2c-1.1,0-2-1.5-1.9-3.3s1.1-3.2,2.2-3.2 C221.3,175.2,222.1,176.7,222,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M248.1,161.6c-0.1,1.6-1,2.9-2,2.9s-1.8-1.4-1.7-3s1-2.9,2-2.9C247.5,158.7,248.2,160,248.1,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M222.5,201.8c0.3,1.4-0.1,2.6-0.9,2.7c-0.8,0.1-1.8-0.9-2.1-2.3c-0.3-1.4,0.1-2.6,0.9-2.8 C221.2,199.3,222.2,200.4,222.5,201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M333.3,71.9c0,1.4-0.7,2.6-1.6,2.6s-1.6-1.2-1.7-2.6c0-1.4,0.7-2.6,1.6-2.6 C332.6,69.4,333.3,70.5,333.3,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M330.6,109.8c-0.1,1.4-0.8,2.5-1.7,2.5c-0.9,0-1.6-1.2-1.6-2.6s0.8-2.5,1.7-2.5 C330,107.2,330.7,108.4,330.6,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M368.5,70.6c0,1.4-0.8,2.5-1.7,2.5c-0.9,0-1.6-1.2-1.6-2.6s0.8-2.5,1.7-2.5 C367.9,68,368.6,69.2,368.5,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M371.6,92.3c-0.1,1.4-0.8,2.5-1.7,2.5c-0.9,0-1.6-1.2-1.6-2.6s0.8-2.5,1.7-2.5 C370.9,89.7,371.6,90.9,371.6,92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M400.2,68.7c0.2,1.4-0.3,2.6-1.3,2.7c-0.9,0.1-1.8-1-2-2.4s0.3-2.6,1.2-2.7 C399.1,66.3,400,67.3,400.2,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M408.6,112.1c0.2,1.4-0.3,2.6-1.2,2.7c-0.9,0.1-1.8-1-2-2.4s0.3-2.6,1.3-2.7 C407.5,109.6,408.4,110.7,408.6,112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M437.8,86.7c0.5,1.4,0.1,2.6-0.8,2.8c-0.9,0.2-2-0.8-2.4-2.1c-0.5-1.4-0.1-2.6,0.8-2.8 C436.3,84.4,437.4,85.4,437.8,86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M454.5,120.3c0.4,1.4,0,2.6-0.8,2.8c-0.9,0.2-1.9-0.8-2.4-2.2c-0.4-1.4,0-2.6,0.8-2.8 C453.1,118,454.1,118.9,454.5,120.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M476.8,99.4c0.4,1.4,0,2.6-0.8,2.8s-1.9-0.8-2.4-2.2c-0.4-1.4,0-2.6,0.8-2.8 C475.3,97,476.4,98,476.8,99.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1NewHair4);
export default __webpack_public_path__ + "static/media/m-hat1_new-hair4.2372e5bc1f60ae5eb482d37678b0ae30.svg";
export { ForwardRef as ReactComponent };